import RectangleStack from "@/assets/icons/rectangle-stack.svg";
import StatusPage, { StatusPageProps } from "@/containers/StatusPages";

const EmptySavedSearches: React.FunctionComponent<Partial<StatusPageProps>> = (
  props
) => {
  return (
    <StatusPage
      icon={RectangleStack}
      title={L.SAVED_SEARCH_EMPTY_TITLE}
      subtitle={L.SAVED_SEARCH_EMPTY_SUBTITLE}
      {...props}
    />
  );
};

export default EmptySavedSearches;
